const BaseColors = ['#259384', '#2C2E4A', '#4A0D2C'];

export { BaseColors };
